module.exports = __webpack_public_path__ + "static/PHP_Wordpress-Iphone-513a830cad167335e269d9efe0531428.mp4";